module.exports = __webpack_public_path__ + "static/media/iitm_campus.c4136ff3.jpg";